/* eslint-disable */
/**
 * @name convertList
 * @description 分组列表扁平化,暂时只支持一级列表
 * @param {Array} datasource
 */
import getTypeof from '@/common/contact-selector/utils/getTypeof';

function encodeQQNumber(originQQ) {
    let qq = originQQ;
    qq += '';
    return `${qq.substr(0, 1)}*******${qq.substr(-1)}`;
}

function convertList(datasource, maps, moreConfig, parentNodeId) {
    const newData = [];
    const config = {
        totalState: true,
        transformItem: null,
        ...(moreConfig || {})
    };
    maps = {
        list: 'list',
        groupName: 'groupName',
        groupId: 'groupId',
        total: 'total',
        ...maps
    };
    datasource.forEach((baseItem, index) => {
        let listItem = maps.list ? baseItem[maps.list] : [];
        if (getTypeof(listItem) === 'array' || baseItem.type === 'group' || Object.prototype.hasOwnProperty.call(baseItem, maps.list)) {
            listItem = listItem || [];
            const newNodeId = typeof parentNodeId !== 'undefined' ? `${index}_${parentNodeId}` : `${index}`;
            const total = typeof baseItem[maps.total] === 'undefined' ? listItem.length : baseItem[maps.total];
            let groupData = {
                type: 'group',
                selectState: 'empty',
                expand: false,
                cookie: '', // 分页加载的标识
                total,
                loaded: true,
                ...baseItem
            };

            groupData.nodeId = newNodeId;
            groupData.uuid = newNodeId;

            // 如果不是全量数据标记分组需要加载
            if (!config.totalState) {
                if ((!listItem || listItem.length === 0) && total !== 0) {
                    groupData.loaded = false;
                }
            }

            groupData.groupName = baseItem[maps.groupName];

            if (listItem && listItem.length) {
                listItem = listItem.map(item => {
                    let newItem = {};
                    if (getTypeof(item) !== 'object') {
                        newItem = {
                            id: item,
                            loaded: false
                        };
                    } else if (!item.face && item.type !== 'group') {
                        newItem = item;
                        item.loaded = false;
                    } else {
                        newItem = item;
                    }
                    newItem.nodeId = newNodeId;
                    newItem.uuid = `c${newItem.nodeId}${newItem.id}`;

                    if (config.transformItem && typeof config.transformItem === 'function') {
                        newItem = config.transformItem(newItem);
                    }
                    return newItem;
                });
                delete groupData[maps.list];
                groupData.groupList = convertList(listItem, maps, config, newNodeId);
            } else {
                groupData.groupList = [];
            }

            if (config.transformGroup && typeof config.transformGroup === 'function') {
                groupData = config.transformGroup(groupData);
            }
            newData.push(groupData);
        } else {
            let newItem = Object.assign({}, baseItem);
            newItem.id = baseItem.uin ? baseItem.uin : baseItem.id;
            // 统一转变为字符串
            newItem.id = `${newItem.id}`;
            try {
                if (config.base.sourceType === 'people' && newItem.sourceType && config.extendConfig.people.qqNumberHide) {
                    newItem.encodeQQNumber = encodeQQNumber(newItem.id);
                }
            }catch(err) {
                // no code
            }
            newItem.nodeId = parentNodeId || '__root';
            newItem.uuid = `c${newItem.nodeId}${newItem.id}`;
            newItem.groupId = baseItem[maps.groupId];
            // 这里在数据结构设计上有一些问题，数据源类型和数据元素类型都用了sourceType，产生了歧义，后面会陆续修改数据元素类型为metaSourceType
            if (baseItem.sourceType) {
                delete newItem.sourceType;
                newItem.metaSourceType = baseItem.sourceType;
            }
            if (!newItem.face) {
                newItem.loaded = false;
            }
            if (config.transformItem && typeof config.transformItem === 'function') {
                newItem = config.transformItem(newItem);
            }
            newData.push(newItem);
        }
    });
    return newData;
}

export default convertList;
